var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbrCloudError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 122,
    viewBox: "0 0 142 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.6155 17.2104C28.5195 7.67038 38.8515 1.47838 50.2275 0.506383C61.7835 -0.501617 74.7075 7.13039 90.9075 20.5224C120.572 44.9664 144.548 53.2824 140.876 78.4464C137.204 103.61 101.204 126.29 73.6635 121.214C46.1235 116.138 14.1555 91.4784 13.3635 54.7224C13.0035 37.4784 17.6115 25.3104 22.6155 17.2104Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.63856 68.0064C11.456 68.0064 14.5506 64.9118 14.5506 61.0944C14.5506 57.277 11.456 54.1824 7.63856 54.1824C3.82117 54.1824 0.726562 57.277 0.726562 61.0944C0.726562 64.9118 3.82117 68.0064 7.63856 68.0064Z",
    fill: "url(#paint0_linear_11098_3921)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M112.073 31.5024C117.839 31.5024 122.513 26.8283 122.513 21.0624C122.513 15.2966 117.839 10.6224 112.073 10.6224C106.307 10.6224 101.633 15.2966 101.633 21.0624C101.633 26.8283 106.307 31.5024 112.073 31.5024Z",
    fill: "url(#paint1_linear_11098_3921)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M119.96 114.23C121.869 114.23 123.416 112.683 123.416 110.774C123.416 108.866 121.869 107.318 119.96 107.318C118.051 107.318 116.504 108.866 116.504 110.774C116.504 112.683 118.051 114.23 119.96 114.23Z",
    fill: "url(#paint2_linear_11098_3921)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M74.0581 95.3664C95.0339 95.3664 112.038 78.3621 112.038 57.3864C112.038 36.4106 95.0339 19.4064 74.0581 19.4064C53.0823 19.4064 36.0781 36.4106 36.0781 57.3864C36.0781 78.3621 53.0823 95.3664 74.0581 95.3664Z",
    fill: "url(#paint3_linear_11098_3921)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9979 99.3264C49.9019 99.3264 32.8379 82.2624 32.8379 61.1664C32.8379 40.0704 49.9019 23.0064 70.9979 23.0064C92.0939 23.0064 109.158 40.1784 109.158 61.1664C109.158 82.2624 92.0939 99.3264 70.9979 99.3264ZM70.9979 18.2544C47.3819 18.2544 28.0859 37.4424 28.0859 61.1664C28.0859 84.8904 47.3819 104.078 70.9979 104.078C94.722 104.078 113.91 84.8904 113.91 61.1664C113.91 37.4424 94.614 18.2544 70.9979 18.2544Z",
    fill: "#7F8087"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0903 48.5304L83.7423 45.1824C78.8463 49.9344 74.5623 54.1104 70.9983 57.8184C67.4343 54.2544 63.1142 49.9344 58.3622 45.1824L55.0143 48.5304C55.0143 48.5304 61.0982 54.6144 67.6503 61.1664C59.2982 69.5184 55.0143 73.8024 54.9062 73.9104L58.2543 77.2584C58.3623 77.1504 64.4463 71.0664 70.8903 64.6224C77.3343 71.0664 83.4183 77.1504 83.5263 77.2584L86.8743 73.9104C86.8743 73.9104 82.4463 69.4824 74.1303 61.1664C80.8983 54.6144 87.0903 48.5304 87.0903 48.5304Z",
    fill: "#7F8087"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11098_3921",
    x1: 0.716122,
    y1: 61.0917,
    x2: 14.5703,
    y2: 61.0917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0025835,
    stopColor: "#CDD0D3",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F8087",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11098_3921",
    x1: 101.661,
    y1: 21.048,
    x2: 122.52,
    y2: 21.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0025835,
    stopColor: "#CDD0D3",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F8087",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11098_3921",
    x1: 116.48,
    y1: 110.789,
    x2: 123.407,
    y2: 110.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0025835,
    stopColor: "#CDD0D3",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F8087",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11098_3921",
    x1: 36.0781,
    y1: 57.3864,
    x2: 112.038,
    y2: 57.3864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F8087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD0D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrCloudError);
export default __webpack_public_path__ + "static/media/ubr-cloud-error.24080e1c941f80d25d4f4c7a2a4f63a8.svg";
export { ForwardRef as ReactComponent };